import type { FC } from 'react'
import { Navigate } from 'react-router-dom'

// a React Node that decides depending on the location hash where it's supposed to go
// this is required so that entry-URLs linking to the configurator can supply configurations
// note: currently just a demonstration

export const EntryRouting: FC = () => {
  const hash = window.location.hash
  if (!hash) {
    return <Navigate to="/setup" replace={true} />
  }
  return <Navigate to="/configuration" replace={true} />
}
